(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["guarantee-badges"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('click', function (event) {
      var heading = event.target.closest('.sbgb-heading');
      if (!heading || heading.tagName !== 'BUTTON') return;

      var item = heading.closest('.sbgb-item');
      if (!item) return;

      var isOpen = item.classList.toggle('is-open');
      heading.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
